import { DefaultTool } from '@blocksuite/affine-block-surface';
import { menu } from '@blocksuite/affine-components/context-menu';
import {
  LocaleProvider,
  translateBlocksuiteText,
} from '@blocksuite/affine-shared/services';
import type { DenseMenuBuilder } from '@blocksuite/affine-widget-edgeless-toolbar';
import { FrameIcon } from '@blocksuite/icons/lit';

import { EdgelessFrameManagerIdentifier } from '../frame-manager.js';
import { FrameTool } from '../frame-tool';
import { FrameConfig } from './config.js';

export const buildFrameDenseMenu: DenseMenuBuilder = (edgeless, gfx) => {
  const locale = edgeless.std.getOptional(LocaleProvider);
  const translate = (key: string, fallback: string) =>
    translateBlocksuiteText(locale, key, fallback);

  return menu.subMenu({
    name: translate('com.affine.blocksuite.frame.tool.frame', 'Frame'),
    prefix: FrameIcon({ width: '20px', height: '20px' }),
    select: () => gfx.tool.setTool(FrameTool),
    isSelected: gfx.tool.currentToolName$.peek() === 'frame',
    options: {
      items: [
        menu.action({
          name: translate('com.affine.blocksuite.frame.tool.custom', 'Custom'),
          select: () => gfx.tool.setTool(FrameTool),
        }),
        ...FrameConfig.map(config =>
          menu.action({
            name: translate(
              'com.affine.blocksuite.frame.tool.slide',
              'Slide {{name}}'
            ).replace('{{name}}', config.name),
            select: () => {
              const frame = edgeless.std.get(EdgelessFrameManagerIdentifier);
              gfx.tool.setTool(DefaultTool);
              frame.createFrameOnViewportCenter(config.wh);
            },
          })
        ),
      ],
    },
  });
};
